import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DavinciLanguageService {

  constructor() { }

  /**
   * This function is a placeholder and no longer performs language synchronization.
   * Deep linking has been disabled.
   * @returns Always `false`.
   */
  public synchronizeAndCheckForReload(): boolean {
    console.log('DavinciLanguageService: Language synchronization and deep linking are not required.');
    return false;
  }
}
